<script setup>
import { ref } from 'vue';
import { useUISettings } from 'dashboard/composables/useUISettings';
import { useAlert } from 'dashboard/composables';
import { useI18n } from 'vue-i18n';
import NextButton from 'dashboard/components-next/button/Button.vue';

const props = defineProps({
  show: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['close']);

const { t } = useI18n();
const { isEditorHotKeyEnabled, updateUISettings } = useUISettings();

// 'enter' → Enter sends, 'cmd_enter' → Cmd/Ctrl+Enter sends.
const selectedKey = ref(
  isEditorHotKeyEnabled('enter') ? 'enter' : 'cmd_enter'
);

const onClose = () => emit('close');

const onSave = () => {
  updateUISettings({ editor_message_key: selectedKey.value });
  useAlert(t('CONVERSATION.SEND_SETTINGS.UPDATE_SUCCESS'));
  onClose();
};
</script>

<template>
  <woot-modal :show="show" :on-close="onClose" size="!w-[420px]">
    <div class="flex flex-col p-6">
      <woot-modal-header
        :header-title="$t('CONVERSATION.SEND_SETTINGS.TITLE')"
      />
      <div class="mt-4">
        <h4 class="text-sm font-medium text-n-slate-12 mb-1">
          {{ $t('CONVERSATION.SEND_SETTINGS.SECTION_TITLE') }}
        </h4>
        <p class="text-sm text-n-slate-11 mb-4">
          {{ $t('CONVERSATION.SEND_SETTINGS.SECTION_DESC') }}
        </p>
        <label
          class="flex items-center gap-2 py-2 cursor-pointer text-sm text-n-slate-12"
        >
          <input
            v-model="selectedKey"
            type="radio"
            name="editorMessageKey"
            value="cmd_enter"
          />
          {{ $t('CONVERSATION.SEND_SETTINGS.CMD_ENTER') }}
        </label>
        <label
          class="flex items-center gap-2 py-2 cursor-pointer text-sm text-n-slate-12"
        >
          <input
            v-model="selectedKey"
            type="radio"
            name="editorMessageKey"
            value="enter"
          />
          {{ $t('CONVERSATION.SEND_SETTINGS.ENTER') }}
        </label>
      </div>
      <div class="flex items-center justify-start gap-2 mt-6">
        <NextButton
          :label="$t('CONVERSATION.SEND_SETTINGS.SAVE')"
          size="sm"
          color="blue"
          @click="onSave"
        />
        <NextButton
          :label="$t('CONVERSATION.SEND_SETTINGS.CANCEL')"
          size="sm"
          variant="ghost"
          color="slate"
          @click="onClose"
        />
      </div>
    </div>
  </woot-modal>
</template>
